import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class AnalyticsAdminPaths {
  static analyticsAdmin = new EnhancedPath('/analytics-admin');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: AnalyticsAdminPaths.analyticsAdmin.path,
      component: lazyWithRetry(() => import('app/pages/system/analyticsAdmin')),
      pageCode: PAGE_CODES.ANALYTICS_ADMIN,
    },
  ],
};

export default routesConfig;
